module.exports = __webpack_public_path__ + "media/images/content/pic_direction_w-f21c0ad05e098a01320d1915b7ef423b.svg";